import React, { useCallback } from 'react'
import { useCompany } from '../../../../api/company/hooks'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { Step5AresProps } from '../types'

const useStep5Ares = (activationObject?: ActivationObject): Step5AresProps => {
    const [icoSearch, setIcoSearch] = React.useState<string>(activationObject?.ico || '')
    const handleSetIcoSearch = useCallback((val: string) => {
        setIcoSearch(val)
    }, [])

    const { data: aresData, isLoading, isFetched } = useCompany(icoSearch)

    React.useEffect(() => {
        setIcoSearch(activationObject?.ico || '')
    }, [activationObject?.ico])

    return {
        companyData: aresData,
        icoSearch,
        handleSetIcoSearch,
        isLoading,
        notFound: icoSearch !== aresData?.ic && isFetched && !isLoading,
    }
}

export default useStep5Ares
